// extracted by mini-css-extract-plugin
export default {"viewSwitch":"my-repertoire_viewSwitch__EhhTW","viewActive":"my-repertoire_viewActive__X7IKh"};